import CryptoJS from "crypto-js";

export function encryptData(text) {
  var KEY = "12345678909805668314220304050607";
  var IV = "1234567890980563"; //16 bits
  var key = CryptoJS.enc.Utf8.parse(KEY);
  var iv = CryptoJS.enc.Utf8.parse(IV);

  var encrypted = "";

  var srcs = CryptoJS.enc.Utf8.parse(text);
  encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.ciphertext.toString();
}

export function decryptData(text) {
  var KEY = "12345678909805668314220304050607"; // 32-bit key
  var IV = "1234567890980563"; // 16-bit IV
  var key = CryptoJS.enc.Utf8.parse(KEY);
  var iv = CryptoJS.enc.Utf8.parse(IV);

  // Convert the hex string to a WordArray
  var encryptedHexStr = CryptoJS.enc.Hex.parse(text);

  // Decrypt using AES with CBC mode and PKCS7 padding
  var decrypted = CryptoJS.AES.decrypt(
    { ciphertext: encryptedHexStr }, // Pass the ciphertext as a WordArray
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  // Convert decrypted data to UTF-8 string
  return decrypted.toString(CryptoJS.enc.Utf8);
}

// export function decryptData(text) {
//   var KEY = "12345678909805668314220304050607"; //32 bit
//   var IV = "1234567890980563"; //16 bits
//   var key = CryptoJS.enc.Utf8.parse(KEY);
//   var iv = CryptoJS.enc.Utf8.parse(IV);

//   var decrypted = "";

//   var srcs = CryptoJS.enc.Utf8.parse(text);
//   decrypted = CryptoJS.AES.decrypt(srcs, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   });

//   return decrypted.ciphertext.toString();
// }
